import { getStateKey } from './utils';
import PROGRESS from '@shopee/api-progress';

import type {
  MartSearchItemsStore,
  MartSearchQueryRewrite,
  MartSearchResult,
} from './types';
import { Item } from '@shopee/item-card-sdk';
import type { SearchParams } from '@shopee/search-common-util';
import type { ProgressType } from '@shopee/api-progress';

export function getMartSearchResult(
  store: MartSearchItemsStore | void,
  searchParams: SearchParams
): MartSearchResult | void {
  if (!store) {
    return void 0;
  }
  const key = getStateKey(searchParams);
  return store[key];
}

export function getMartSearchResultProgress(
  store: MartSearchItemsStore | void,
  searchParams: SearchParams
): ProgressType {
  const searchResult = getMartSearchResult(store, searchParams);
  return (searchResult && searchResult.progress) || PROGRESS.INIT;
}

export function getMartSearchResultNextOffset(
  store: MartSearchItemsStore | void,
  searchParams: SearchParams
): number {
  const searchResult = getMartSearchResult(store, searchParams);
  return (searchResult && searchResult.nextOffset) || 0;
}

export function getMartSearchResultTotal(
  store: MartSearchItemsStore | void,
  searchParams: SearchParams
): number {
  const searchResult = getMartSearchResult(store, searchParams);
  return (searchResult && searchResult.total_count) || 0;
}

const EMPTY_SEARCH_ITEMS: Item[] = [];

export function getMartSearchResultItems(
  store: MartSearchItemsStore | void,
  searchParams: SearchParams
): Item[] {
  const searchResult = getMartSearchResult(store, searchParams);
  return (searchResult && searchResult.items) || EMPTY_SEARCH_ITEMS;
}

export function getMartSearchResultQueryRewrite(
  store: MartSearchItemsStore | void,
  searchParams: SearchParams
): MartSearchQueryRewrite | void {
  const searchResult = getMartSearchResult(store, searchParams);
  return searchResult && searchResult.query_rewrite;
}
